'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _reactRedux = require('react-redux');

var _softwares = require('redux/modules/softwares');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoftwareDownloadPopupOlder = function (_React$Component) {
  (0, _inherits3.default)(SoftwareDownloadPopupOlder, _React$Component);

  function SoftwareDownloadPopupOlder(props) {
    (0, _classCallCheck3.default)(this, SoftwareDownloadPopupOlder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SoftwareDownloadPopupOlder.__proto__ || (0, _getPrototypeOf2.default)(SoftwareDownloadPopupOlder)).call(this, props));

    _this.state = {
      selection: props.updater.filter(function (el, index) {
        return index != 0;
      }).map(function (el) {
        return (0, _utils.detectOperatingSystem)();
      })
    };
    return _this;
  }

  (0, _createClass3.default)(SoftwareDownloadPopupOlder, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selection = nextProps.updater && nextProps.updater.map(function (u) {
        return 'Windows';
      });
      this.setState({ selection: selection });
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'handleOSChange',
    value: function handleOSChange(index, value) {
      var selection = this.state.selection;
      selection[index] = value;
      this.setState({ selection: selection });
    }
  }, {
    key: 'onClickPlatform',
    value: function onClickPlatform(index, value) {
      var selection = this.state.selection;
      selection[index] = value;
      this.setState({ selection: selection });
    }
  }, {
    key: 'renderDownload',
    value: function renderDownload() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          updater = _props.updater,
          icon = _props.icon,
          cover = _props.cover;


      var styles = require('./SoftwareDownloadPopupOlder.scss');

      var renderThumbVertical = function renderThumbVertical() {
        return _react2.default.createElement('div', { style: {
            background: '#A9A9A9',
            width: '8px',
            display: 'block'
          } });
      };

      var renderTrackVertical = function renderTrackVertical(props) {
        return _react2.default.createElement('div', (0, _extends3.default)({}, props, { style: {
            right: 2,
            bottom: 2,
            top: 2,
            borderRadius: 0,
            position: 'absolute',
            width: 8,
            cursor: 'pointer',
            background: '#0F0F0F'
          } }));
      };

      return _react2.default.createElement(
        'div',
        { className: styles.DownloadPopup },
        _react2.default.createElement(
          'div',
          { className: styles.Featured },
          cover.Name
        ),
        _react2.default.createElement(
          _reactCustomScrollbars.Scrollbars,
          { universal: true, autoHeight: true, renderThumbVertical: renderThumbVertical, renderTrackVertical: renderTrackVertical },
          _react2.default.createElement(
            'div',
            { className: styles.DownloadPopup__inner },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.DownloadPopup__Title },
                _react2.default.createElement('img', { src: icon }),
                _react2.default.createElement(
                  'h1',
                  null,
                  title
                )
              )
            ),
            updater.filter(function (el, index) {
              return index != 0;
            }).map(function (latest, index) {
              var operatingSystems = ['Windows'];

              if (!!latest.UrlMac) {
                operatingSystems.push('Mac');
              }

              return _react2.default.createElement(
                'div',
                { className: styles.DownloadPopup__Software },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_components.Button, {
                    className: styles.DownloadPopup__DownloadButton,
                    primary: true,
                    link: true,
                    href: _this2.state.selection[index].toLowerCase() == 'windows' ? latest.Url : latest.UrlMac,
                    label: 'Download ' + (0, _utils.prettyVersion)(latest.Version) })
                ),
                _react2.default.createElement(
                  'div',
                  { style: { marginBottom: '2em' } },
                  _react2.default.createElement(_components.ButtonGroup, { styles: styles, options: operatingSystems, selected: _this2.state.selection[index], onClick: function onClick(value) {
                      return _this2.handleOSChange(index, value);
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles['DownloadPopup__ChangeLog-title'] },
                  'Changelist for ' + (0, _utils.prettyVersion)(latest.Version)
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.DownloadPopup__ChangeLog },
                  _react2.default.createElement(
                    'ul',
                    null,
                    latest.Bullet.map(function (c) {
                      return _react2.default.createElement(
                        'li',
                        null,
                        c
                      );
                    })
                  )
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loading = _props2.loading,
          loaded = _props2.loaded,
          cover = _props2.cover;


      var styles = require('./SoftwareDownloadPopupOlder.scss');

      return _react2.default.createElement(
        _components.PopupBoxWithBackground,
        { image: cover && cover.Url || '', forceClose: this.props.forceClose },
        loading && _react2.default.createElement(
          'div',
          { className: styles.center },
          _react2.default.createElement(_components.LoadingIndicator, null)
        ),
        !loading && loaded && this.renderDownload()
      );
    }
  }]);
  return SoftwareDownloadPopupOlder;
}(_react2.default.Component);

var SoftwareDownloadPopupLatestContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    softwares: state.softwares
  };
}, null, null, { withRef: true }), _dec(_class = function (_React$Component2) {
  (0, _inherits3.default)(SoftwareDownloadPopupLatestContainer, _React$Component2);

  function SoftwareDownloadPopupLatestContainer() {
    (0, _classCallCheck3.default)(this, SoftwareDownloadPopupLatestContainer);
    return (0, _possibleConstructorReturn3.default)(this, (SoftwareDownloadPopupLatestContainer.__proto__ || (0, _getPrototypeOf2.default)(SoftwareDownloadPopupLatestContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(SoftwareDownloadPopupLatestContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props3 = this.props,
          software = _props3.software,
          dispatch = _props3.dispatch,
          softwares = _props3.softwares;


      if (software === 'bridge' && !softwares.bridgeLoaded) dispatch((0, _softwares.loadBridgeUpdater)());

      if (software === 'mixer' && !softwares.mixerLoaded) dispatch((0, _softwares.loadMixerUpdater)());
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          software = _props4.software,
          softwares = _props4.softwares;


      var title = '',
          loading = false,
          loaded = false,
          cover = '',
          icon = '',
          updater = {};

      if (software == 'bridge') {
        title = "Megascans BRIDGE";
        loading = softwares.loadingBridge;
        loaded = softwares.bridgeLoaded;
        updater = softwares.bridgeUpdater;
        cover = softwares.bridgeCover;
        icon = '/icons/bridge_64.jpg';
      }

      if (software == 'mixer') {
        title = "Megascans MIXER";
        loading = softwares.loadingMixer;
        loaded = softwares.mixerLoaded;
        updater = softwares.mixerUpdater;
        cover = softwares.mixerCover;
        icon = '/icons/studio_64.jpg';
      }

      return _react2.default.createElement(SoftwareDownloadPopupOlder, { loading: loading, loaded: loaded, updater: updater, title: title, icon: icon, cover: cover, forceClose: this.forceClose.bind(this) });
    }
  }]);
  return SoftwareDownloadPopupLatestContainer;
}(_react2.default.Component)) || _class);
exports.default = SoftwareDownloadPopupLatestContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SoftwareDownloadPopupOlder/SoftwareDownloadPopupOlder.jsx
// module id = 2738
// module chunks = 0